import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global-service.service';
import { Router } from '@angular/router';
import { Md5} from 'ts-md5/dist/md5';


@Component({
    selector: 'app-benutzer',
    templateUrl: './benutzer.component.html',
    styleUrls: ['../css/pasura.css'],
    standalone: false
})
export class BenutzerComponent implements OnInit {

  constructor(public globserv: GlobalService, private http:HttpClient,  private router: Router) { }

  ngOnInit(): void {
  
  		if (this.globserv.Login.Admin)
  		{
  			this.lodaParuraUsers();
  		}
  }

  pasuraUsers:any;
  passwortAlt="";
  passwortNeu="";
  passwortNeu2="";

  lodaParuraUsers()
  {
  
  		this.pasuraUsers=undefined;
  		
		var data={};
		var resultData;
		
  		this.globserv.getBackendData("/v1/getPasuraUsers",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim suchen der Schadenfälle!"}});	
  					 				console.log("Error");
	  					 			console.log(err);  					 				
  					 		  },
		       () => {
					this.pasuraUsers = resultData.PasuraUsers;
	       		console.log("PasuraUsers " +JSON.stringify(this.pasuraUsers));
			}
		);   
  }
  
  
  doChangePW()
  {
  
  		var data={  		
  		"PasswortMD5": Md5.hashAsciiStr(this.passwortAlt).toString(),
  		"PasswortNewMD5": Md5.hashAsciiStr(this.passwortNeu).toString()
  		};
  		
		var resultData;
		
  		this.globserv.getBackendData("/v1/changePW",data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim ändern des Passwortes"}});	
  					 				console.log("Error");
	  					 			console.log(err);  					 				
  					 		  },
		       () => {
		       
					
	       		console.log("doChangePW " +JSON.stringify(resultData));
	       		if (resultData.ChangePW.OK)
	       		{
	       			this.globserv.setPasuraAction({"msg":{"title":"Passwort", "typ":"success","txt":"Passwort wurde erfolgreich geändert"}});
	       			this.globserv.setPasuraAction('LogOut');
  	  					this.router.navigate(['/login']);
  	  				}else{
  	  				
  	  					this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Passwort konnte nicht geändert werden!"}});	
  	  				}
			}
		);   
  }
}
